import { useEffect, useMemo, useRef } from 'react';

const workerSrc = `
const timers=new Map();
onmessage=e=>{
  const {t,id,ms}=e.data||{};
  if(t==='delay'){const h=setTimeout(()=>{postMessage({id});timers.delete(id)},ms);timers.set(id,h)}
  else if(t==='clear'){const h=timers.get(id); if(h){clearTimeout(h); timers.delete(id)}}
  else if(t==='every'){const h=setInterval(()=>postMessage({id,tick:1}),ms); timers.set(id,h)}
  else if(t==='every-clear'){const h=timers.get(id); if(h){clearInterval(h); timers.delete(id)}}
};
`;

export default function useWorkerDelay() {
  const ids = useRef(0);
  const resolvers = useRef(new Map<number, () => void>());
  const listeners = useRef(new Map<number, () => void>());
  const worker = useMemo(() => {
    const blob = new Blob([workerSrc], { type: 'application/javascript' });
    return new Worker(URL.createObjectURL(blob));
  }, []);
  useEffect(() => {
    const onMsg = (e: MessageEvent) => {
      const { id, tick } = e.data || {};
      if (tick) {
        const cb = listeners.current.get(id);
        cb && cb();
        return;
      }
      const r = resolvers.current.get(id);
      r && r();
      resolvers.current.delete(id);
    };
    worker.addEventListener('message', onMsg);
    return () => {
      worker.removeEventListener('message', onMsg);
      worker.terminate();
    };
  }, [worker]);

  const delay = (ms: number) =>
    new Promise<void>((res) => {
      const id = ++ids.current;
      resolvers.current.set(id, res);
      worker.postMessage({ t: 'delay', id, ms });
    });
  const every = (ms: number, cb: () => void) => {
    const id = ++ids.current;
    listeners.current.set(id, cb);
    worker.postMessage({ t: 'every', id, ms });
    return () => {
      listeners.current.delete(id);
      worker.postMessage({ t: 'every-clear', id });
    };
  };

  return { delay, every };
}
